module.exports = __webpack_public_path__ + "img/worldnet2.79603c18.jpg";